<template>
    <div>
        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'竞品维护'}]"/>
        <div class="bigDiv">
            <div class="h-piece">
                <div class="top">
                    <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                        <h1>需求信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine quqiu">
                            <el-form
                                    :model="f" label-position="right"
                                    ref="f"
                                    :inline="true"
                                    class="demo-ruleForm h-formbLine">
                                <el-form-item
                                        label="拜访时间"
                                        class="h-elformWrap-2">
                                    <el-input
                                            v-model="f.cdate"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="拜访客户" class="h-elformWrap-2" prop="euName">
                                    <el-input v-model="f.euName" :v="f.euName" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="部门科室" class="h-elformWrap-2" prop="department">
                                    <el-input v-model="f.contactDept" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                                    <el-input v-model="f.contact" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                                    <el-input v-model="f.contactPhone" readonly></el-input>
                                </el-form-item>
                                <el-form-item
                                        label="拜访结果"
                                        class="h-elformWrap-2"
                                        prop="formCon11">
                                    <el-input
                                            v-model="f.result"
                                            :v="f.result"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                                <div class="Yong">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                                        <h1>用户在用产品信息</h1>
                                    </div>
                                    <el-form-item
                                            class="h-elformWrap-1 "
                                            style="margin-bottom:0.2rem">
                                        <div class="categoryBox">
                                            <div class="category"
                                                 :class="{'active':item==categorys}"
                                                 @click="selectC(item)"
                                                 v-for="(item,index) in category"
                                                 :key="index"
                                            >
                                                {{item}}
                                            </div>
                                        </div>
                                        <div v-if="categorys == '海尔产品'" style="margin-top:20px;">
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="productList"
													border
                                            >
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="category"
                                                        label="产品大类"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.category"
                                                                   placeholder="--请选择--"
                                                                   filterable
                                                                   @change="changeBigHaierBig(scope.row,scope.$index)"
                                                                   class="h-tableInput"
                                                        >
                                                            <el-option
                                                                    v-for="(item,index) in LevelName"
                                                                    :key="index"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specification"
                                                        label="产品型号"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.specification"
                                                                   placeholder="--请选择--"
                                                                   filterable
                                                                   class="h-tableInput"
                                                        >
                                                            <el-option
                                                                    v-for="(item,index2) in Model[scope.$index]"
                                                                    :key="index2"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="amount"
                                                        label="产品数量"
                                                        width="100">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model.number="scope.row.amount"
                                                                placeholder="数量"
                                                                maxlength="10"
                                                                class="h-tableInput"

                                                                oninput="value=value.replace(/[^\d]/g, '')"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="barCode"
                                                        label="条形码"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.barCode"
                                                                class="h-tableInput"

                                                                placeholder="条形码">
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isOverdue"
                                                        label="是否超限期使用"
                                                        width="150">
                                                    <template scope="scope">
                                                        <brselect
                                                                category="isOverdue"
                                                                :v="scope.row.isOverdue"
                                                                v-model="scope.row.isOverdue"
                                                                class="h-tableInput"

                                                                placeholder="--请选择--">
                                                        </brselect>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="exfactoryDate"
                                                        label="出厂日期"
                                                        class="h-tableInput"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.exfactoryDate"
                                                                type="date"
                                                                value-format="yyyy-MM-dd"
                                                                class="h-tableInput"

                                                                @change="dateChange1">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="purchaseDate"
                                                        label="购买日期"
                                                        class="h-tableInput"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.purchaseDate"
                                                                type="date"
                                                                value-format="yyyy-MM-dd"
                                                                class="h-tableInput"

                                                                @change="dateChange2">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="产品照片"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <brupload
                                                                :refid=scope.row.id
                                                                :reftype=jingpinHaier
                                                                :showtime="showtime"
                                                                uploadflag
                                                                delflag
                                                        >
                                                            <el-button size="small" type="text">上传</el-button>
                                                        </brupload>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        label="备注"
                                                        class="h-tableInput"
                                                        min-width="180">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.remark"
                                                                class="h-tableInput"

                                                                placeholder="备注">
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="操作" fixed="right" width="100">
                                                    <template slot-scope="scope">
                                                       <el-button type="text" size="small"
                                                                   class="h-tableLink h-btn"
                                                                   @click="delPlan(scope.$index)">删除
                                                        </el-button>
														<!-- <div class="l-operationBox">
															<span class="l-operationlist br-operation-delete" title="删除" @click="delPlan(scope.$index)"></span>
														</div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div v-if="categorys == '竞品'" style="margin-top:20px;">
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="jingpinList"
													border
                                                    style="width: 100%"
                                            >
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="category"
                                                        label="产品大类"
                                                        width="170">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.category"
                                                                   placeholder="请选择">
                                                            <el-option
                                                                    v-for="(item) in LevelName"
                                                                    :key="item.id"
                                                                    class="h-tableInput"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specification"
                                                        label="产品型号"
                                                        width="180">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.specification"
                                                                placeholder="产品型号"
                                                                class="h-tableInput"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="amount"
                                                        label="产品数量"
                                                        width="100">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model.number="scope.row.amount"
                                                                placeholder="产品数量"
                                                                maxlength="10"
                                                                class="h-tableInput"
                                                                oninput="value=value.replace(/[^\d]/g, '')"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="barCode"
                                                        label="条形码"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.barCode"
                                                                placeholder="条形码"
                                                                class="h-tableInput"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isOverdue"
                                                        label="是否超限期使用"
                                                        width="150">
                                                    <template scope="scope">
                                                        <brselect
                                                                category="isOverdue"
                                                                :v="scope.row.isOverdue"
                                                                v-model="scope.row.isOverdue"
                                                                placeholder="--请选择--"
                                                                class="h-tableInput"
                                                        >
                                                        </brselect>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="exfactoryDate"
                                                        label="出厂日期"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.exfactoryDate"
                                                                type="date"
                                                                class="h-tableInput"
                                                                value-format="yyyy-MM-dd"
                                                                @change="dateChange1">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="purchaseDate"
                                                        label="购买日期"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.purchaseDate"
                                                                type="date"
                                                                class="h-tableInput"
                                                                value-format="yyyy-MM-dd"
                                                                @change="dateChange2">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="产品照片"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <brupload
                                                                :refid=scope.row.id
                                                                :reftype=jingpinOther
                                                                :showtime="showtime"
                                                                uploadflag
                                                                delflag
                                                        >
                                                            <el-button size="small" type="text">上传</el-button>
                                                        </brupload>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        label="备注" min-width="180">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.remark"
                                                                placeholder="备注"
                                                                class="h-tableInput"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="操作" fixed="right" width="100">
                                                    <template slot-scope="scope">
                                                        <el-button type="text" size="small"
                                                                   class="h-tableLink h-btn"
                                                                   @click="delPlan(scope.$index)">删除
                                                        </el-button>
														<!-- <div class="l-operationBox">
															<span class="l-operationlist br-operation-delete" title="删除" @click="delPlan(scope.$index)"></span>
														</div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div class="h-tableAdd" @click="add">
                                            <a>新增一行</a>
                                        </div>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite"  @click="backL">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveDetail()">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                showUserCare:false,
                EuName:[],
                showtime: false,
                jingpinOther: "竞品拍摄",
                jingpinHaier: "海尔拍摄",
                day1: "",
                day2: "",
                LevelName: [],
                ProModel: [],
                //竞品信息-产品型号
                Model: [{}],
                showS: true,
                showD: false,
                cg: null,
                category: ['海尔产品', '竞品'],
                productList: [{specification: '',type: "1", fromType: '2',id: this.getUUid()}],
                jingpinList: [{specification: '',type: "2", fromType: '2',id: this.getUUid()}],
                categorys: '海尔产品',
                tableList: [],
                tableDate: [],
                p1: null,
                p2: null,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                customer: {
                    areaCode: null,
                    channelCode: null,
                },
                //带线表单
                f: {
                    productInfoList: [],
                    id: '',
                    date1: '',
                    date2: '',
                    euName: '',
                    demandType: '',
                    userCode: '',
                    content: '',
                    euCode: '',
                    euType: null,
                    bidConvDate: '',
                    expConvDate: '',
                    bidPercentage: '',
                    areaCode: null,
                    channelCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    userCare: {
                        result: null,
                        cdate: null,
                        planRemark: null
                    },
                    detail: {
                        proCode: '',
                        proModel: '',
                        proNumber: '',
                        proPrice: '',
                        proTotalAmount: '',
                    },
                    proMain: {
                        isSuccess: null,
                        projectName: '',
                    },
                },
            }
        },
        methods: {
            customerType() {
                this.f.euName = null;
                this.customer.channelCode = null;
                this.f.contactuserName = null;
                this.f.department = null;
                this.f.telephone = null;
                this.customer.areaCode = null;
                this.EuName=null;
            },
            //通过用户名带出详细信息
            showFormList(value) {
                this.f.userName = value;
                if (this.f.euType == 1) {
                    ss.UserCare.agentOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                } else if (this.f.euType == 2) {
                    ss.UserCare.customerOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                }
            },
            showForm() {
                for (var i = 0; i < this.EuName.length; i++) {
                    if (this.f.euName == this.EuName[i].userName) {
                        this.f.euCode = this.EuName[i].userCode;
                        this.f.areaCode = this.EuName[i].areaCode;
                        this.f.channelCode = this.EuName[i].channelCode;
                        this.customer.areaCode = this.$getDictName("YLRegion", this.EuName[i].areaCode);
                        this.customer.channelCode = this.$getDictName("sales_region", this.EuName[i].channelCode);
                        this.f.contactuserName = this.EuName[i].contactuserName;
                        this.f.department = this.EuName[i].department;
                        this.f.telephone = this.EuName[i].telephone;
                    }
                }
            },
            totalprice(){
                if(this.f.detail.proNumber!=null && this.f.detail.proPrice!=null){
                    this.f.detail.proTotalAmount = this.f.detail.proNumber * this.f.detail.proPrice;
                }
            },
            numMAX(value) {
                if (value < 1) {
                    this.f.bidPercentage = 1;
                } else if (value > 100) {
                    this.f.bidPercentage = 100;
                }
            },
            selectC(item) {
                this.categorys = item;
            },
            //产品大类初始化
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //大类选择-大类修改时，当块数据proProduct[i]-v,index-i
            changeBigHaierBig(v,i){
                v.specification='';
                this.selectProductHaier(v.category,i);
            },
            //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProductHaier(v,i) {
                ss.ProService.product2Select(v).then(rd => {
                    this.Model[i] = rd;
                    this.$set(this.Model,i,rd);
                })
            },
            //产品信息-产品型号
            selectproModel(value) {
                this.f.detail.proModel = '';
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            showproModel(value) {
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            showAllproModel() {
                ss.UserDemand.showAllproModel().then(rd => {
                    this.Model = rd;
                })
            },
            dateChange1(val) {
                console.log(val);
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day1 = date.getTime();
                if (this.day2 < this.day1) {
                    if (this.day2 == 0) {
                        return;
                    }
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.f.purchaseDate = "";
                }
            },
            dateChange2(val) {
                console.log(val);
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day2 = date.getTime()
                if (this.day2 < this.day1) {
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.f.purchaseDate = "";
                }
            },
            query() {
                    this.f.executionId= this.$route.query.id;
                    ss.UserCare.planDetail2(this.f).then(rd => {
                        this.f = rd.plan.userCareExecution;
                        rd.plan.productInfoList.forEach((item,index)=>{
                            if (item.type == "1") {
                                this.productList.push(item);
                            } else if (item.type == "2") {
                                this.jingpinList.push(item);
                            }
                        });
                        if (this.productList.length > 1) {
                            this.productList.splice(0, 1);
                        }
                        if (this.jingpinList.length > 1) {
                            this.jingpinList.splice(0, 1);
                        }
                        this.productList.forEach((item,index)=>{
                            this.selectProductHaier(item.category,index);
                        })
                    });
            },
            getUUid() {
                return  this.$util.getUuid();
            },
            add() {
                var list = {
                    id: this.getUUid(),
                    category: '',
                    specification: '',
                    amount: '',
                    barCode: '',
                    exfactoryDate: '',
                    purchaseDate: '',
                    remark: '',
                    type: '',
                    fromType: '2',
                    fromId: '',
                }
                if (this.categorys == '海尔产品') {
                    list.type = "1";
                    list.fromType = '2';
                    this.productList.push(list);
                } else if (this.categorys == '竞品') {
                    list.type = "2";
                    list.fromType = '2';
                    this.jingpinList.push(list);
                }
            },
            delPlan(index) {
                if (this.categorys == '海尔产品') {
                    this.productList.splice(index, 1);
                } else if (this.categorys == '竞品') {
                    this.jingpinList.splice(index, 1);
                }
            },
            saveDetail() {
                    this.$msg.confirm("确认提交?", () => {
                        this.f.productInfoList=[];
                        for (var i = 0; i < this.productList.length; i++) {
                            if (this.productList[i].category != null && this.productList[i].specification != null) {
                                this.f.productInfoList.push(this.productList[i]);
                            }
                        }
                        for (var i = 0; i < this.jingpinList.length; i++) {
                            if (this.jingpinList[i].category != null && this.jingpinList[i].specification != null) {
                                this.f.productInfoList.push(this.jingpinList[i]);
                            }
                        }
                        ss.UserCare.saveJingPin(this.f).then(rd => {
                            this.$msg.msgs("操作成功");
                            this.$router.push({
                                path: "/guanhuai"
                            });
                        });
                    });
            },
            backL() {
                this.$router.push({
                    path: "/xuqiu/Lmanagement"
                });
            },

            delIndex(index) {
                this.proProduct.splice(index, 1)
                //console.log(index,"删除一行数据");
            },
        },
        created() {
            this.options2 = this.$store.getters.dicts["userCareType"];
            this.customerType();
            this.query();
            this.showLevelName();
            this.showAllproModel();
        }
    }
</script>

<style scoped>
    .categoryBox {
        display: flex;
        border-bottom: 1px solid #dcdfe1;
    }

    .bigDiv {
        margin: 20px;
    }

    .categoryBox .category {
        width: 122px;
        height: 36px;
        color: #b0b0b0;
        font-size: 0.2rem;
        text-align: center;
        line-height: 36px;
        margin-left: 20px;
        border: 1px solid #b4b4b4;
        cursor: pointer;
        border-bottom: 0;
    }

    .categoryBox .category:first-child {
        margin-left: 0;
    }

    .categoryBox .category.active {
        color: #fff;
        border: 1px solid #0e75e9;
        background: #0e75e9;
    }

    .quqiu {
        margin-top: 0.38rem
    }
</style>
<style>
    .quqiu .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .quqiu .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .quqiu .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .quqiu .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .quqiu .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
        margin-bottom: 20px;
    }

    .quqiu .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 100%;
    }

    .h-piece .top .h-formbLine .Yong .el-form-item__content .el-input__inner {
        border-bottom: none;
        text-align: center;
    }

    .h-piece .top .h-formbLine .Yong .el-form-item__content .el-input__inner:focus {
        border: 1px solid #2785e7;
        box-shadow: 0 0 0.16rem rgba(39, 133, 231, 0.35) inset;
        border-radius: 4px;
        height: 40px;
    }

    .h-tableInput .el-input {
        height: 100%;
    }

    .el-table tbody td .cell {
        padding: 6px;
    }
</style>
